import { Injectable } from '@angular/core';
import { CONFIG } from "../../config/config";
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PurchaseProductsService {

  constructor(
    public http: HttpClient,
    public router: Router,
  ) { }

  getAllPurchaseProducts() {
    return this.http.get(`${CONFIG.API_PROD}purchase_products`)
  }

}